import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from '../../../shared/api'

// ── Types ─────────────────────────────────────────────────────────────────────

export interface NonFoodItem {
  id: number
  schuleId: string
  schuleFirmaId: string | null
  kategorie: string | null
  bezeichnung: string
  menge: number
  einheit: string | null
  ort: string | null
  zustand: string | null
  anschaffungsdatum: string | null
  bemerkung: string | null
  audit_created_at: string | null
  audit_created_by: string | null
  audit_modified_at: string | null
  audit_modified_by: string | null
}

export interface NonFoodInput {
  schuleId?: string
  kategorie?: string | null
  bezeichnung: string
  menge: number
  einheit?: string | null
  ort?: string | null
  zustand?: string | null
  anschaffungsdatum?: string | null
  bemerkung?: string | null
}

// ── Hooks ─────────────────────────────────────────────────────────────────────

export function useInventarNonFood(schuleId: string | null) {
  return useQuery({
    queryKey: ['inventar-non-food', schuleId],
    queryFn: () =>
      api.get<NonFoodItem[]>(`/api/inventar/non-food?schuleId=${encodeURIComponent(schuleId!)}`),
    enabled: !!schuleId,
    staleTime: 5 * 60_000,
  })
}

export function useCreateNonFood() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (data: NonFoodInput) =>
      api.post<{ id: number }>('/api/inventar/non-food', data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['inventar-non-food'] }),
  })
}

export function useUpdateNonFood() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: Partial<NonFoodInput> }) =>
      api.put<{ ok: boolean }>(`/api/inventar/non-food/${id}`, data),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['inventar-non-food'] }),
  })
}

export function useDeleteNonFood() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: (id: number) =>
      api.delete<{ ok: boolean }>(`/api/inventar/non-food/${id}`),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['inventar-non-food'] }),
  })
}
